import { NumberInput, SelectInput, TextField, TextInput } from "react-admin";
import { JsonField } from "../../ra-lb-tools/components/jsonField";
import { MyList } from "../../ra-lb-tools/components/myList";
import { MyReferencesField } from "../../ra-lb-tools/components/myReference";
import { MonetizationOnOutlined } from "@mui/icons-material";
import { MyCreate } from "../../ra-lb-tools/components/myMutator";
import { ProductInput } from "./products";
import { Box } from "@mui/material";
import { Debug } from "../../ra-lb-tools/components/debug";
import { StripeLink } from "./stripeLink";
import { CurrencyCentsField } from "../../ra-lb-tools/components/currencyField";

export const PriceIcon = MonetizationOnOutlined;

const intervalChoices = [
  {
    id: "day",
    name: "day",
  },
  {
    id: "week",
    name: "week",
  },
  {
    id: "month",
    name: "month",
  },
  {
    id: "year",
    name: "year",
  },
];

export const ProductPriceList = (props) => {
  return <PriceList filter={{ productId: props.productId }} />;
};

export const PriceList = (props) => {
  return (
    <MyList {...props}>
      <Box source="id">
        <TextField source="id" />
        <Debug>
          <StripeLink id="id" />
        </Debug>
      </Box>
      <TextField source="nickname" />
      <TextField source="currency" />
      <TextField source="billing_scheme" />
      <TextField source="product" label={"Product id"} />
      <MyReferencesField
        reference="products"
        source="product"
        target="processorId"
      />
      <TextField source="tiers" />
      <TextField source="tiers_mode" />
      <CurrencyCentsField source="unit_amount" />
      <JsonField source="recurring" />
    </MyList>
  );
};

PriceList.defaultProps = {
  title: "Prices",
  resource: "prices",
  filter: {},
};

export const PricesCreate = (props) => {
  return (
    <MyCreate
      {...props}
      transform={(data) => ({
        ...data,
        unitAmount: data.unitAmount * 100,
      })}
    >
      <TextInput source="nickname" />
      <ProductInput source="productId" />
      <NumberInput source="unitAmount" />
      <SelectInput source="interval" choices={intervalChoices} />
    </MyCreate>
  );
};
